<template>
  <div class="animated fadeIn" id="Hssk831-page-update">
    <div class="card">
      <div class="card-body p-4">
        <b-row class="mb-3">
          <b-col md="12" class="text-center bold">
            <h5 v-if="mData.viewMode == 'update'">
              CẬP NHẬP HỒ SƠ SỨC KHỎE CÁ NHÂN
            </h5>
            <h5 v-if="mData.viewMode == 'create'">
              THÊM MỚI HỒ SƠ SỨC KHỎE CÁ NHÂN
            </h5>
          </b-col>
          <div style="position: absolute; right: 24px; top: 15px">
            <el-button type="info" plain @click="fn_gotoDetail"
              >Quay lại</el-button
            >
          </div>
        </b-row>

        <!-- mục B -->
        <div>
          <b-row class="mb-2 mt-4">
            <b-col md="12" class="bold-500"
              >B. NHÓM THÔNG TIN TIỀN SỬ VÀ CÁC YẾU TỐ LIÊN QUAN SỨC KHỎE</b-col
            >
          </b-row>
          <b-row>
            <el-form
              :model="mData.dataForm"
              :rules="mData.validForm"
              ref="myFormB"
              label-width="100%"
              label-position="top"
              class="w-100x"
            >
              <b-col md="12">
                <b-tabs
                  card
                  pills
                  vertical
                  nav-wrapper-class="w-200"
                  v-model="tabIndex[1]"
                >
                  <b-tab active>
                    <template slot="title">1. Tình trạng lúc sinh</template>
                    <b-row class="mb-2">
                      <b-col md="6" class="bold-500 link color-primary"
                        >Lịch sử chỉnh sửa</b-col
                      >
                      <b-col md="6" class="text-right">
                        <el-button type="info" plain @click="fn_updateB1()">{{
                          aLang.c_update
                        }}</el-button>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="3">
                        <span>
                          <el-radio
                            v-model="
                              mData.dataForm.ThongTinHanhChinh
                                .B1_TinhTrangLucSinh
                            "
                            :label="1"
                            >Đẻ thường</el-radio
                          >
                        </span>
                      </b-col>
                      <b-col md="3">
                        <span>
                          <el-radio
                            v-model="
                              mData.dataForm.ThongTinHanhChinh
                                .B1_TinhTrangLucSinh
                            "
                            :label="2"
                            >Đẻ mổ</el-radio
                          >
                        </span>
                      </b-col>
                      <b-col md="3">
                        <span class="form-label">Đẻ thiếu tháng:</span>
                        <span>
                          <el-checkbox
                            v-model="
                              mData.dataForm.ThongTinHanhChinh.B1_DeThieuThang
                            "
                          ></el-checkbox>
                        </span>
                      </b-col>
                      <b-col md="3">
                        <span class="form-label">Bị ngạt lúc đẻ:</span>
                        <span>
                          <el-checkbox
                            v-model="
                              mData.dataForm.ThongTinHanhChinh.B1_BiNgatLucDe
                            "
                          ></el-checkbox>
                        </span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="3">
                        <el-form-item label="Cân nặng lúc đẻ (gr):">
                          <el-input-number
                            :placeholder="aLang.c_insertContent"
                            v-model="
                              mData.dataForm.ThongTinHanhChinh.B1_CanNang
                            "
                            :precision="1"
                            :min="0"
                          ></el-input-number>
                        </el-form-item>
                      </b-col>
                      <b-col md="3">
                        <el-form-item label="Chiều dài lúc đẻ (cm):">
                          <el-input-number
                            :placeholder="aLang.c_insertContent"
                            v-model="
                              mData.dataForm.ThongTinHanhChinh.B1_ChieuDaiLucDe
                            "
                            :precision="1"
                            :min="0"
                          ></el-input-number>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item label="Dị tật bẩm sinh (ghi rõ nếu có):">
                          <el-input
                            :placeholder="aLang.c_insertContent"
                            v-model="
                              mData.dataForm.ThongTinHanhChinh.B1_DiTatBamSinh
                            "
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item label="Vấn đề khác (ghi rõ nếu có):">
                          <el-input
                            :placeholder="aLang.c_insertContent"
                            v-model="mData.dataForm.ThongTinHanhChinh.B1_Khac"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab>
                    <template slot="title"
                      >2. Yếu tố nguy cơ đối với SKCN</template
                    >
                    <b-row class="mb-2">
                      <b-col md="6" class="bold-500 link color-primary"
                        >Lịch sử chỉnh sửa</b-col
                      >
                      <b-col md="6" class="text-right">
                        <el-button type="info" plain @click="fn_updateB2()">{{
                          aLang.c_update
                        }}</el-button>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col md="12">
                        <table
                          border="1"
                          cellspacing="0"
                          cellpadding="8"
                          width="100%"
                          bordercolor="#777777"
                          style="border-collapse: collapse"
                        >
                          <tr>
                            <td>
                              <span>Hút thuốc lá, lào</span>
                            </td>
                            <td>
                              <div>
                                <el-radio
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B2_HutThuoc
                                  "
                                  :label="false"
                                  >Không</el-radio
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-radio
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B2_HutThuoc
                                  "
                                  :label="true"
                                  >Có</el-radio
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B2_HutThuoc_ThuongXuyen
                                  "
                                  >Hút thường xuyên</el-checkbox
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B2_HutThuoc_DaBo
                                  "
                                  >Đã bỏ</el-checkbox
                                >
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span>Uống rượu bia thường xuyên</span>
                            </td>
                            <td>
                              <div>
                                <el-radio
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B2_UongRuouBia
                                  "
                                  :label="false"
                                  >Không</el-radio
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-radio
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B2_UongRuouBia
                                  "
                                  :label="true"
                                  >Có</el-radio
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-form-item
                                  label="Số ly cốc uống/ngày"
                                  class="mb-0 d-flex"
                                >
                                  <el-input-number
                                    class="ml-1"
                                    v-model="
                                      mData.dataForm.ThongTinHanhChinh
                                        .B2_UongRuouBia_SoCoc
                                    "
                                    :min="0"
                                  ></el-input-number>
                                </el-form-item>
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B2_UongRuouBia_DaBo
                                  "
                                  >Đã bỏ</el-checkbox
                                >
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span>Sử dụng ma túy</span>
                            </td>
                            <td>
                              <div>
                                <el-radio
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B2_MaTuy
                                  "
                                  :label="false"
                                  >Không</el-radio
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-radio
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B2_MaTuy
                                  "
                                  :label="true"
                                  >Có</el-radio
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B2_MaTuy_ThuongXuyen
                                  "
                                  >Sử dụng thường xuyên</el-checkbox
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B2_MaTuy_DaBo
                                  "
                                  >Đã bỏ</el-checkbox
                                >
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span>Hoạt động thể lực</span>
                            </td>
                            <td>
                              <div>
                                <el-radio
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B2_HoatDongTheLuc
                                  "
                                  :label="false"
                                  >Không</el-radio
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-radio
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B2_HoatDongTheLuc
                                  "
                                  :label="true"
                                  >Có</el-radio
                                >
                              </div>
                            </td>
                            <td colspan="2">
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B2_HoatDongTheLuc_ThuongXuyen
                                  "
                                  >Thường xuyên (tập thể dục, thể
                                  thao...)</el-checkbox
                                >
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <b-row>
                                <b-col md="12">
                                  <el-form-item
                                    label="Yếu tố tiếp xúc nghề nghiệp/ Môi trường sống (Hóa chất, bụi, ồn, virút...) ghi rõ yếu tố tiếp xúc:"
                                  >
                                    <el-input
                                      :placeholder="aLang.c_insertContent"
                                      v-model="
                                        mData.dataForm.ThongTinHanhChinh
                                          .B2_YeuToTiepXuc
                                      "
                                    ></el-input>
                                  </el-form-item>
                                </b-col>
                                <b-col md="6">
                                  <el-form-item label="Thời gian tiếp xúc:">
                                    <el-input
                                      :placeholder="aLang.c_insertContent"
                                      v-model="
                                        mData.dataForm.ThongTinHanhChinh
                                          .B2_ThoiGianTiepXuc
                                      "
                                    ></el-input>
                                  </el-form-item>
                                </b-col>
                              </b-row>
                              <b-row>
                                <b-col md="12">
                                  <el-form-item
                                    label="Loại hố xí của gia đình (xả nước/ hai ngăn/ hố xí thùng/ không có hố xí):"
                                  >
                                    <el-input
                                      :placeholder="aLang.c_insertContent"
                                      v-model="
                                        mData.dataForm.ThongTinHanhChinh
                                          .B2_LoaiHoXi
                                      "
                                    ></el-input>
                                  </el-form-item>
                                </b-col>
                              </b-row>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5">
                              <b-row>
                                <b-col md="12">
                                  <el-form-item label="Nguy cơ khác (ghi rõ):">
                                    <el-input
                                      :placeholder="aLang.c_insertContent"
                                      v-model="
                                        mData.dataForm.ThongTinHanhChinh
                                          .B2_NguyCoKhac
                                      "
                                    ></el-input>
                                  </el-form-item>
                                </b-col>
                              </b-row>
                            </td>
                          </tr>
                        </table>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab>
                    <template slot="title"
                      >3. Tiền sử bệnh tật, dị ứng</template
                    >
                    <b-row class="mb-2">
                      <b-col md="6" class="bold-500 link color-primary"
                        >Lịch sử chỉnh sửa</b-col
                      >
                      <b-col md="6" class="text-right">
                        <el-button type="info" plain @click="fn_updateB3()">{{
                          aLang.c_update
                        }}</el-button>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col md="12" class="bold-500">Dị ứng:</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col md="12">
                        <table
                          border="1"
                          cellspacing="0"
                          cellpadding="8"
                          width="100%"
                          bordercolor="#777777"
                          style="border-collapse: collapse"
                        >
                          <tr>
                            <td class="bold-500" style="width: 4cm">
                              <span>Loại</span>
                            </td>
                            <td class="bold-500">
                              <span>Mô tả rõ</span>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Thuốc</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_DiUngThuoc
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Hóa chất/ mỹ phẩm</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_DiUngHoaChatMyPham
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Thực phẩm</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_DiUngThucPham
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Khác</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_DiUngKhac
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col md="12" class="bold-500">Bệnh tật:</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col md="12">
                        <table
                          border="1"
                          cellspacing="0"
                          cellpadding="8"
                          width="100%"
                          bordercolor="#777777"
                          style="border-collapse: collapse"
                        >
                          <tr>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_BenhTimMach
                                  "
                                  >Bệnh tim mạch</el-checkbox
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_BenhTangHuyetAp
                                  "
                                  >Tăng huyết áp</el-checkbox
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_BenhDaiDuong
                                  "
                                  >Đái tháo đường</el-checkbox
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_BenhDaDay
                                  "
                                  >Bệnh dạ dày</el-checkbox
                                >
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_BenhPhoiManTinh
                                  "
                                  >Bệnh phổi mạn tính</el-checkbox
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_BenhHenSuyen
                                  "
                                  >Hen suyễn</el-checkbox
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_BenhBuouCo
                                  "
                                  >Bệnh bướu cổ</el-checkbox
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_BenhViemGan
                                  "
                                  >Viêm gan</el-checkbox
                                >
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_BenhTimBamSinh
                                  "
                                  >Tim bẩm sinh</el-checkbox
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_BenhTamThan
                                  "
                                  >Tâm thần</el-checkbox
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B3_BenhTuKy
                                  "
                                  >Tự kỷ</el-checkbox
                                >
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B3_BenhDongKinh
                                  "
                                  >Động kinh</el-checkbox
                                >
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div>
                                <el-form-item
                                  label="Ung thư (ghi rõ loại ung thư):"
                                >
                                  <el-input
                                    :placeholder="aLang.c_insertContent"
                                    v-model="
                                      mData.dataForm.ThongTinHanhChinh
                                        .B3_BenhUngThu
                                    "
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div>
                                <el-form-item label="Lao (ghi rõ loại lao):">
                                  <el-input
                                    :placeholder="aLang.c_insertContent"
                                    v-model="
                                      mData.dataForm.ThongTinHanhChinh
                                        .B3_BenhLao
                                    "
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="4">
                              <div>
                                <el-form-item label="Khác (nêu rõ):">
                                  <el-input
                                    :placeholder="aLang.c_insertContent"
                                    v-model="
                                      mData.dataForm.ThongTinHanhChinh
                                        .B3_BenhKhac
                                    "
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab>
                    <template slot="title">4. Khuyết tật</template>
                    <b-row class="mb-2">
                      <b-col md="6" class="bold-500 link color-primary"
                        >Lịch sử chỉnh sửa</b-col
                      >
                      <b-col md="6" class="text-right">
                        <el-button type="info" plain @click="fn_updateB4()">{{
                          aLang.c_update
                        }}</el-button>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col md="12">
                        <table
                          border="1"
                          cellspacing="0"
                          cellpadding="8"
                          width="100%"
                          bordercolor="#777777"
                          style="border-collapse: collapse"
                        >
                          <tr>
                            <td class="bold-500" style="width: 4cm">
                              <span>Bộ phận/ cơ quan</span>
                            </td>
                            <td class="bold-500">
                              <span>Mô tả rõ</span>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Thính lực</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B4_ThinhLuc
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Thị lực</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B4_ThiLuc
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Tay</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B4_Tay
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Chân</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B4_Chan
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Cong vẹo cột sống</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B4_CongVeoCotSong
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td style="width: 4cm">
                              <span>Khe hở môi, vòm miệng</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B4_HoMoi
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Khác</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B4_Khac
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab>
                    <template slot="title">5. Tiền sử phẫu thuật</template>
                    <b-row class="mb-2">
                      <b-col md="6" class="bold-500 link color-primary"
                        >Lịch sử chỉnh sửa</b-col
                      >
                      <b-col md="6" class="text-right">
                        <el-button type="info" plain @click="fn_updateB5()">{{
                          aLang.c_update
                        }}</el-button>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col md="12">
                        <div>
                          <el-input
                            :placeholder="aLang.c_insertContent"
                            v-model="
                              mData.dataForm.ThongTinHanhChinh
                                .B5_TienSuPhauThuat
                            "
                            type="textarea"
                            rows="10"
                          ></el-input>
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab>
                    <template slot="title">6. Tiền sử gia đình</template>
                    <b-row class="mb-2">
                      <b-col md="6" class="bold-500 link color-primary"
                        >Lịch sử chỉnh sửa</b-col
                      >
                      <b-col md="6" class="text-right">
                        <el-button type="info" plain @click="fn_updateB6()">{{
                          aLang.c_update
                        }}</el-button>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col md="12" class="bold-500">Dị ứng:</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col md="12">
                        <table
                          border="1"
                          cellspacing="0"
                          cellpadding="8"
                          width="100%"
                          bordercolor="#777777"
                          style="border-collapse: collapse"
                        >
                          <tr>
                            <td class="bold-500" style="width: 4cm">
                              <span>Loại</span>
                            </td>
                            <td class="bold-500">
                              <span>Mô tả rõ</span>
                            </td>
                            <td class="bold-500">
                              <span
                                >Người mắc (ghi rõ quan hệ huyết thống: ông, bà,
                                bố, mẹ, anh, chị, em,...)</span
                              >
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Thuốc</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDDiUngThuoc
                                  "
                                ></el-input>
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDDiUngThuoc_NguoiMac
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Hóa chất/ mỹ phẩm</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDDiUngHoaChatMyPham
                                  "
                                ></el-input>
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDDiUngHoaChatMyPham_NguoiMac
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Thực phẩm</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDDiUngThucPham
                                  "
                                ></el-input>
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDDiUngThucPham_NguoiMac
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 4cm">
                              <span>Khác</span>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDDiUngKhac
                                  "
                                ></el-input>
                              </div>
                            </td>
                            <td>
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDDiUngKhac_NguoiMac
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col md="12" class="bold-500">Bệnh tật:</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col md="12">
                        <table
                          border="1"
                          cellspacing="0"
                          cellpadding="8"
                          width="100%"
                          bordercolor="#777777"
                          style="border-collapse: collapse"
                        >
                          <tr>
                            <td class="bold-500" style="width: 6cm">
                              <span>Tên bệnh</span>
                            </td>
                            <td class="bold-500"></td>
                            <td class="bold-500">
                              <span
                                >Người mắc (ghi rõ quan hệ huyết thống: ông, bà,
                                bố, mẹ, anh, chị, em,...)</span
                              >
                            </td>
                            <td class="bold-500" style="width: 6cm">
                              <span>Tên bệnh</span>
                            </td>
                            <td class="bold-500"></td>
                            <td class="bold-500">
                              <span
                                >Người mắc (ghi rõ quan hệ huyết thống: ông, bà,
                                bố, mẹ, anh, chị, em,...)</span
                              >
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 6cm">
                              <span class="form-label">Bệnh tim mạch</span>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDBenhTim
                                  "
                                ></el-checkbox>
                              </div>
                            </td>
                            <td>
                              <el-input
                                :placeholder="aLang.c_insertContent"
                                v-model="
                                  mData.dataForm.ThongTinHanhChinh
                                    .B6_GDBenhTim_NguoiMac
                                "
                              ></el-input>
                            </td>
                            <td>
                              <span class="form-label">Hen suyễn</span>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDHenSuyen
                                  "
                                ></el-checkbox>
                              </div>
                            </td>
                            <td>
                              <el-input
                                :placeholder="aLang.c_insertContent"
                                v-model="
                                  mData.dataForm.ThongTinHanhChinh
                                    .B6_GDHenSuyen_NguoiMac
                                "
                              ></el-input>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 6cm">
                              <span class="form-label">Tăng huyết áp</span>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDTangHuyetAp
                                  "
                                ></el-checkbox>
                              </div>
                            </td>
                            <td>
                              <el-input
                                :placeholder="aLang.c_insertContent"
                                v-model="
                                  mData.dataForm.ThongTinHanhChinh
                                    .B6_GDTangHuyetAp_NguoiMac
                                "
                              ></el-input>
                            </td>
                            <td>
                              <span class="form-label">Đái tháo đường</span>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDDaiDuong
                                  "
                                ></el-checkbox>
                              </div>
                            </td>
                            <td>
                              <el-input
                                :placeholder="aLang.c_insertContent"
                                v-model="
                                  mData.dataForm.ThongTinHanhChinh
                                    .B6_GDDaiDuong_NguoiMac
                                "
                              ></el-input>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 6cm">
                              <span class="form-label">Tâm thần</span>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDTamThan
                                  "
                                ></el-checkbox>
                              </div>
                            </td>
                            <td>
                              <el-input
                                :placeholder="aLang.c_insertContent"
                                v-model="
                                  mData.dataForm.ThongTinHanhChinh
                                    .B6_GDTamThan_NguoiMac
                                "
                              ></el-input>
                            </td>
                            <td>
                              <span class="form-label">Động kinh</span>
                            </td>
                            <td>
                              <div>
                                <el-checkbox
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh
                                      .B6_GDDongKinh
                                  "
                                ></el-checkbox>
                              </div>
                            </td>
                            <td>
                              <el-input
                                :placeholder="aLang.c_insertContent"
                                v-model="
                                  mData.dataForm.ThongTinHanhChinh
                                    .B6_GDDongKinh_NguoiMac
                                "
                              ></el-input>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <span class="form-label"
                                >Ung thư (ghi rõ loại ung thư, người mắc, quan
                                hệ):</span
                              >
                            </td>
                            <td colspan="3">
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B6_GDUngThu
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <span class="form-label"
                                >Lao (ghi rõ loại lao, người mắc, quan
                                hệ):</span
                              >
                            </td>
                            <td colspan="3">
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B6_GDLao
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <span class="form-label"
                                >Khác (ghi rõ người mắc, quan hệ):</span
                              >
                            </td>
                            <td colspan="3">
                              <div>
                                <el-input
                                  :placeholder="aLang.c_insertContent"
                                  v-model="
                                    mData.dataForm.ThongTinHanhChinh.B6_GDKhac
                                  "
                                ></el-input>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab>
                    <template slot="title"
                      >7. Sức khỏe sinh sản và kế hoạch hóa gia đình</template
                    >
                    <b-row class="mb-2">
                      <b-col md="6" class="bold-500 link color-primary"
                        >Lịch sử chỉnh sửa</b-col
                      >
                      <b-col md="6" class="text-right">
                        <el-button type="info" plain @click="fn_updateB7()">{{
                          aLang.c_update
                        }}</el-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <div>
                          <el-form-item label="Biện pháp tránh thai đang dùng:">
                            <el-input
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh
                                  .B7_BienPhapTranhThay
                              "
                            ></el-input>
                          </el-form-item>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <div>
                          <el-form-item label="Kỳ có thai cuối cùng:">
                            <el-input
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh
                                  .B7_KyThaiCuoiCung
                              "
                              :disabled="
                                mData.dataForm.ThongTinHanhChinh.GIOI_TINH ==
                                '1'
                              "
                            ></el-input>
                          </el-form-item>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <div>
                          <el-form-item label="Số lần có thai:">
                            <el-input-number
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh.B7_SoLanCoThay
                              "
                              :disabled="
                                mData.dataForm.ThongTinHanhChinh.GIOI_TINH ==
                                '1'
                              "
                              :min="0"
                            ></el-input-number>
                          </el-form-item>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div>
                          <el-form-item label="Số lần sảy thai:">
                            <el-input-number
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh.B7_SoLanSayThay
                              "
                              :disabled="
                                mData.dataForm.ThongTinHanhChinh.GIOI_TINH ==
                                '1'
                              "
                              :min="0"
                            ></el-input-number>
                          </el-form-item>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div>
                          <el-form-item label="Số lần phá thai:">
                            <el-input-number
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh.B7_SoLanPhaThay
                              "
                              :disabled="
                                mData.dataForm.ThongTinHanhChinh.GIOI_TINH ==
                                '1'
                              "
                              :min="0"
                            ></el-input-number>
                          </el-form-item>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3">
                        <div>
                          <el-form-item label="Số lần sinh đẻ:">
                            <el-input-number
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh.B7_SoLanSinhDe
                              "
                              :disabled="
                                mData.dataForm.ThongTinHanhChinh.GIOI_TINH ==
                                '1'
                              "
                              :min="0"
                            ></el-input-number>
                          </el-form-item>
                        </div>
                      </b-col>
                      <b-col md="3">
                        <div>
                          <el-form-item label="Số lần đẻ thường:">
                            <el-input-number
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh
                                  .B7_SoLanDeThuong
                              "
                              :disabled="
                                mData.dataForm.ThongTinHanhChinh.GIOI_TINH ==
                                '1'
                              "
                              :min="0"
                            ></el-input-number>
                          </el-form-item>
                        </div>
                      </b-col>
                      <b-col md="3">
                        <div>
                          <el-form-item label="Số lần đẻ mổ:">
                            <el-input-number
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh.B7_SoLanDeMo
                              "
                              :disabled="
                                mData.dataForm.ThongTinHanhChinh.GIOI_TINH ==
                                '1'
                              "
                              :min="0"
                            ></el-input-number>
                          </el-form-item>
                        </div>
                      </b-col>
                      <b-col md="3">
                        <div>
                          <el-form-item label="Số lần đẻ khó:">
                            <el-input-number
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh.B7_SoLanDeKho
                              "
                              :disabled="
                                mData.dataForm.ThongTinHanhChinh.GIOI_TINH ==
                                '1'
                              "
                              :min="0"
                            ></el-input-number>
                          </el-form-item>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <div>
                          <el-form-item label="Số lần đẻ đủ tháng:">
                            <el-input-number
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh
                                  .B7_SoLanDeDuThang
                              "
                              :disabled="
                                mData.dataForm.ThongTinHanhChinh.GIOI_TINH ==
                                '1'
                              "
                              :min="0"
                            ></el-input-number>
                          </el-form-item>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div>
                          <el-form-item label="Số lần đẻ non:">
                            <el-input-number
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh.B7_SoLanDeNon
                              "
                              :disabled="
                                mData.dataForm.ThongTinHanhChinh.GIOI_TINH ==
                                '1'
                              "
                              :min="0"
                            ></el-input-number>
                          </el-form-item>
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div>
                          <el-form-item label="Số con sống hiện tại:">
                            <el-input-number
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh
                                  .B7_SoConSongHienTai
                              "
                              :disabled="
                                mData.dataForm.ThongTinHanhChinh.GIOI_TINH ==
                                '1'
                              "
                              :min="0"
                            ></el-input-number>
                          </el-form-item>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <div>
                          <el-form-item label="Bệnh phụ khoa:">
                            <el-input
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh.B7_BenhPhuKhoa
                              "
                              :disabled="
                                mData.dataForm.ThongTinHanhChinh.GIOI_TINH ==
                                '1'
                              "
                            ></el-input>
                          </el-form-item>
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab>
                    <template slot="title">8. Vấn đề khác</template>
                    <b-row class="mb-2">
                      <b-col md="6" class="bold-500 link color-primary"
                        >Lịch sử chỉnh sửa</b-col
                      >
                      <b-col md="6" class="text-right">
                        <el-button type="info" plain @click="fn_updateB8()">{{
                          aLang.c_update
                        }}</el-button>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col md="12">
                        <div>
                          <el-form-item label>
                            <el-input
                              :placeholder="aLang.c_insertContent"
                              v-model="
                                mData.dataForm.ThongTinHanhChinh.B8_CacVanDeKhac
                              "
                              type="textarea"
                              rows="10"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
              </b-col>
            </el-form>
          </b-row>
        </div>
      </div>
    </div>

    <!-- modal B2-->
    <el-dialog
      title="Lịch sử chỉnh sửa"
      :visible.sync="mData.dialog.dialogB2.visibleDialog"
      width="70%"
      top="51px"
      :close-on-click-modal="false"
    >
      <div class="card-body">
        <b-row class="mb-2">
          <b-col md="6" class="bold-500">Chỉnh sửa ngày: 05/02/2020</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12">
            <table
              border="1"
              cellspacing="0"
              cellpadding="8"
              width="100%"
              bordercolor="#777777"
              style="border-collapse: collapse"
            >
              <tr>
                <td>
                  <span>Hút thuốc lá, lào</span>
                </td>
                <td>
                  <div>
                    <span class="form-label">Không</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="!mData.dataForm.ThongTinHanhChinh.B2_HutThuoc"
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Có</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="mData.dataForm.ThongTinHanhChinh.B2_HutThuoc"
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Hút thường xuyên</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="
                          mData.dataForm.ThongTinHanhChinh
                            .B2_HutThuoc_ThuongXuyen
                        "
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Đã bỏ</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="
                          mData.dataForm.ThongTinHanhChinh.B2_HutThuoc_DaBo
                        "
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Uống rượu bia thường xuyên</span>
                </td>
                <td>
                  <div>
                    <span class="form-label">Không</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="
                          !mData.dataForm.ThongTinHanhChinh.B2_UongRuouBia
                        "
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Có</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="mData.dataForm.ThongTinHanhChinh.B2_UongRuouBia"
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Số ly cốc uống/ngày</span>
                    <span class="form-value">{{
                      mData.dataForm.ThongTinHanhChinh.B2_UongRuouBia_SoCoc ||
                      "&nbsp;"
                    }}</span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Đã bỏ</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="
                          mData.dataForm.ThongTinHanhChinh.B2_UongRuouBia_DaBo
                        "
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Sử dụng ma túy</span>
                </td>
                <td>
                  <div>
                    <span class="form-label">Không</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="!mData.dataForm.ThongTinHanhChinh.B2_MaTuy"
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Có</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="mData.dataForm.ThongTinHanhChinh.B2_MaTuy"
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Sử dụng thường xuyên</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="
                          mData.dataForm.ThongTinHanhChinh.B2_MaTuy_ThuongXuyen
                        "
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Đã bỏ</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="mData.dataForm.ThongTinHanhChinh.B2_MaTuy_DaBo"
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Hoạt động thể lực</span>
                </td>
                <td>
                  <div>
                    <span class="form-label">Không</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="
                          !mData.dataForm.ThongTinHanhChinh.B2_HoatDongTheLuc
                        "
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Có</span>
                    <span>
                      <el-checkbox
                        disabled
                        :value="
                          mData.dataForm.ThongTinHanhChinh.B2_HoatDongTheLuc
                        "
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
                <td colspan="2">
                  <div>
                    <span class="form-label"
                      >Thường xuyên (tập thể dục, thể thao...)</span
                    >
                    <span>
                      <el-checkbox
                        disabled
                        :value="
                          mData.dataForm.ThongTinHanhChinh
                            .B2_HoatDongTheLuc_ThuongXuyen
                        "
                      ></el-checkbox>
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <b-row>
                    <b-col md="12"
                      >Yếu tố tiếp xúc nghề nghiệp/ Môi trường sống (Hóa chất,
                      bụi, ồn, virút...) ghi rõ yếu tố tiếp xúc:</b-col
                    >
                    <b-col md="6">
                      <span class="form-value">{{
                        mData.dataForm.ThongTinHanhChinh.B2_YeuToTiepXuc ||
                        "&nbsp;"
                      }}</span>
                    </b-col>
                    <b-col md="3">
                      <span class="form-label">Thời gian tiếp xúc:</span>
                      <span class="form-value">{{
                        mData.dataForm.ThongTinHanhChinh.B2_ThoiGianTiepXuc ||
                        "&nbsp;"
                      }}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <span class="form-label"
                        >Loại hố xí của gia đình (xả nước/ hai ngăn/ hố xí
                        thùng/ không có hố xí):</span
                      >
                      <span class="form-value">{{
                        mData.dataForm.ThongTinHanhChinh.B2_LoaiHoXi || "&nbsp;"
                      }}</span>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <b-row>
                    <b-col md="12">
                      <span class="form-label">Nguy cơ khác (ghi rõ):</span>
                      <span class="form-value">{{
                        mData.dataForm.ThongTinHanhChinh.B2_NguyCoKhac ||
                        "&nbsp;"
                      }}</span>
                    </b-col>
                  </b-row>
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>
      </div>
    </el-dialog>

    <!-- modal B3-->
    <el-dialog
      title="Lịch sử chỉnh sửa"
      :visible.sync="mData.dialog.dialogB3.visibleDialog"
      width="70%"
      top="51px"
      :close-on-click-modal="false"
    >
      <div class="card-body">
        <b-row class="mb-2">
          <b-col md="6" class="bold-500">Chỉnh sửa ngày: 05/02/2020</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12" class="bold-500">Dị ứng:</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12">
            <table
              border="1"
              cellspacing="0"
              cellpadding="8"
              width="100%"
              bordercolor="#777777"
              style="border-collapse: collapse"
            >
              <tr>
                <td class="bold-500" style="width: 4cm">
                  <span>Loại</span>
                </td>
                <td class="bold-500">
                  <span>Mô tả rõ</span>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Thuốc</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B3_DiUngThuoc || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Hóa chất/ mỹ phẩm</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B3_DiUngHoaChatMyPham ||
                      "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Thực phẩm</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B3_DiUngThucPham ||
                      "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Khác</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B3_DiUngKhac || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="12" class="bold-500">Bệnh tật:</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12">
            <table
              border="1"
              cellspacing="0"
              cellpadding="8"
              width="100%"
              bordercolor="#777777"
              style="border-collapse: collapse"
            >
              <tr>
                <td>
                  <div>
                    <span class="form-label">Bệnh tim mạch</span>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B3_BenhTimMach"
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Tăng huyết áp</span>
                    <el-checkbox
                      disabled
                      :value="
                        mData.dataForm.ThongTinHanhChinh.B3_BenhTangHuyetAp
                      "
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Đái tháo đường</span>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B3_BenhDaiDuong"
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Bệnh dạ dày</span>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B3_BenhDaDay"
                    ></el-checkbox>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <span class="form-label">Bệnh phổi mạn tính</span>
                    <el-checkbox
                      disabled
                      :value="
                        mData.dataForm.ThongTinHanhChinh.B3_BenhPhoiManTinh
                      "
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Hen suyễn</span>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B3_BenhHenSuyen"
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Bệnh bướu cổ</span>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B3_BenhBuouCo"
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Viêm gan</span>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B3_BenhViemGan"
                    ></el-checkbox>
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                  <div>
                    <span class="form-label">Tim bẩm sinh</span>
                    <el-checkbox
                      disabled
                      :value="
                        mData.dataForm.ThongTinHanhChinh.B3_BenhTimBamSinh
                      "
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Tâm thần</span>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B3_BenhTamThan"
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Tự kỷ</span>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B3_BenhTuKy"
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <div>
                    <span class="form-label">Động kinh</span>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B3_BenhDongKinh"
                    ></el-checkbox>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div>
                    <span class="form-label"
                      >Ung thư (ghi rõ loại ung thư):</span
                    >
                    <span class="form-value">{{
                      mData.dataForm.ThongTinHanhChinh.B3_BenhUngThu || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div>
                    <span class="form-label">Lao (ghi rõ loại lao):</span>
                    <span class="form-value">{{
                      mData.dataForm.ThongTinHanhChinh.B3_BenhLao || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <div>
                    <span class="form-label">Khác (nêu rõ):</span>
                    <span class="form-value">{{
                      mData.dataForm.ThongTinHanhChinh.B3_BenhKhac || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>
      </div>
    </el-dialog>

    <!-- modal B4-->
    <el-dialog
      title="Lịch sử chỉnh sửa"
      :visible.sync="mData.dialog.dialogB4.visibleDialog"
      width="70%"
      top="51px"
      :close-on-click-modal="false"
    >
      <div class="card-body">
        <b-row class="mb-2">
          <b-col md="6" class="bold-500">Chỉnh sửa ngày: 05/02/2020</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12">
            <table
              border="1"
              cellspacing="0"
              cellpadding="8"
              width="100%"
              bordercolor="#777777"
              style="border-collapse: collapse"
            >
              <tr>
                <td class="bold-500" style="width: 4cm">
                  <span>Bộ phận/ cơ quan</span>
                </td>
                <td class="bold-500">
                  <span>Mô tả rõ</span>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Thính lực</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B4_ThinhLuc || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Thị lực</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B4_ThiLuc || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Tay</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B4_Tay || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Chân</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B4_Chan || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Cong vẹo cột sống</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B4_CongVeoCotSong ||
                      "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>

              <tr>
                <td style="width: 4cm">
                  <span>Khe hở môi, vòm miệng</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B4_HoMoi || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Khác</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B4_Khac || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>
      </div>
    </el-dialog>

    <!-- modal B5-->
    <el-dialog
      title="Lịch sử chỉnh sửa"
      :visible.sync="mData.dialog.dialogB5.visibleDialog"
      width="70%"
      top="51px"
      :close-on-click-modal="false"
    >
      <div class="card-body">
        <b-row class="mb-2">
          <b-col md="6" class="bold-500">Chỉnh sửa ngày: 05/02/2020</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12">
            <div>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B5_TienSuPhauThuat || "&nbsp;"
              }}</span>
            </div>
          </b-col>
        </b-row>
      </div>
    </el-dialog>

    <!-- modal B6-->
    <el-dialog
      title="Lịch sử chỉnh sửa"
      :visible.sync="mData.dialog.dialogB6.visibleDialog"
      width="70%"
      top="51px"
      :close-on-click-modal="false"
    >
      <div class="card-body">
        <b-row class="mb-2">
          <b-col md="6" class="bold-500">Chỉnh sửa ngày: 05/02/2020</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12" class="bold-500">Dị ứng:</b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="12">
            <table
              border="1"
              cellspacing="0"
              cellpadding="8"
              width="100%"
              bordercolor="#777777"
              style="border-collapse: collapse"
            >
              <tr>
                <td class="bold-500" style="width: 4cm">
                  <span>Loại</span>
                </td>
                <td class="bold-500">
                  <span>Mô tả rõ</span>
                </td>
                <td class="bold-500">
                  <span
                    >Người mắc (ghi rõ quan hệ huyết thống: ông, bà, bố, mẹ,
                    anh, chị, em,...)</span
                  >
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Thuốc</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B6_GDDiUngThuoc ||
                      "&nbsp;"
                    }}</span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh
                        .B6_GDDiUngThuoc_NguoiMac || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Hóa chất/ mỹ phẩm</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh
                        .B6_GDDiUngHoaChatMyPham || "&nbsp;"
                    }}</span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh
                        .B6_GDDiUngHoaChatMyPham_NguoiMac || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Thực phẩm</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B6_GDDiUngThucPham ||
                      "&nbsp;"
                    }}</span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh
                        .B6_GDDiUngThucPham_NguoiMac || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="width: 4cm">
                  <span>Khác</span>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B6_GDDiUngKhac ||
                      "&nbsp;"
                    }}</span>
                  </div>
                </td>
                <td>
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh
                        .B6_GDDiUngKhac_NguoiMac || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="12" class="bold-500">Bệnh tật:</b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="12">
            <table
              border="1"
              cellspacing="0"
              cellpadding="8"
              width="100%"
              bordercolor="#777777"
              style="border-collapse: collapse"
            >
              <tr>
                <td class="bold-500" style="width: 6cm">
                  <span>Tên bệnh</span>
                </td>
                <td class="bold-500"></td>
                <td class="bold-500">
                  <span
                    >Người mắc (ghi rõ quan hệ huyết thống: ông, bà, bố, mẹ,
                    anh, chị, em,...)</span
                  >
                </td>
                <td class="bold-500" style="width: 6cm">
                  <span>Tên bệnh</span>
                </td>
                <td class="bold-500"></td>
                <td class="bold-500">
                  <span
                    >Người mắc (ghi rõ quan hệ huyết thống: ông, bà, bố, mẹ,
                    anh, chị, em,...)</span
                  >
                </td>
              </tr>
              <tr>
                <td style="width: 6cm">
                  <span class="form-label">Bệnh tim mạch</span>
                </td>
                <td>
                  <div>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B6_GDBenhTim"
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <span class>{{
                    mData.dataForm.ThongTinHanhChinh.B6_GDBenhTim_NguoiMac ||
                    "&nbsp;"
                  }}</span>
                </td>
                <td>
                  <span class="form-label">Hen suyễn</span>
                </td>
                <td>
                  <div>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B6_GDHenSuyen"
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <span class>{{
                    mData.dataForm.ThongTinHanhChinh.B6_GDHenSuyen_NguoiMac ||
                    "&nbsp;"
                  }}</span>
                </td>
              </tr>
              <tr>
                <td style="width: 6cm">
                  <span class="form-label">Tăng huyết áp</span>
                </td>
                <td>
                  <div>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B6_GDTangHuyetAp"
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <span class>{{
                    mData.dataForm.ThongTinHanhChinh
                      .B6_GDTangHuyetAp_NguoiMac || "&nbsp;"
                  }}</span>
                </td>
                <td>
                  <span class="form-label">Đái tháo đường</span>
                </td>
                <td>
                  <div>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B6_GDDaiDuong"
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <span class>{{
                    mData.dataForm.ThongTinHanhChinh.B6_GDDaiDuong_NguoiMac ||
                    "&nbsp;"
                  }}</span>
                </td>
              </tr>
              <tr>
                <td style="width: 6cm">
                  <span class="form-label">Tâm thần</span>
                </td>
                <td>
                  <div>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B6_GDTamThan"
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <span class>{{
                    mData.dataForm.ThongTinHanhChinh.B6_GDTamThan_NguoiMac ||
                    "&nbsp;"
                  }}</span>
                </td>
                <td>
                  <span class="form-label">Động kinh</span>
                </td>
                <td>
                  <div>
                    <el-checkbox
                      disabled
                      :value="mData.dataForm.ThongTinHanhChinh.B6_GDDongKinh"
                    ></el-checkbox>
                  </div>
                </td>
                <td>
                  <span class>{{
                    mData.dataForm.ThongTinHanhChinh.B6_GDDongKinh_NguoiMac ||
                    "&nbsp;"
                  }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span class="form-label"
                    >Ung thư (ghi rõ loại ung thư, người mắc, quan hệ):</span
                  >
                </td>
                <td colspan="3">
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B6_GDUngThu || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span class="form-label"
                    >Lao (ghi rõ loại lao, người mắc, quan hệ):</span
                  >
                </td>
                <td colspan="3">
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B6_GDLao || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span class="form-label"
                    >Khác (ghi rõ người mắc, quan hệ):</span
                  >
                </td>
                <td colspan="3">
                  <div>
                    <span class>{{
                      mData.dataForm.ThongTinHanhChinh.B6_GDKhac || "&nbsp;"
                    }}</span>
                  </div>
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>
      </div>
    </el-dialog>

    <!-- modal B7-->
    <el-dialog
      title="Lịch sử chỉnh sửa"
      :visible.sync="mData.dialog.dialogB7.visibleDialog"
      width="70%"
      top="51px"
      :close-on-click-modal="false"
    >
      <div class="card-body">
        <b-row class="mb-2">
          <b-col md="6" class="bold-500">Chỉnh sửa ngày: 05/02/2020</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12">
            <div>
              <span class="form-label">Biện pháp tránh thai đang dùng:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_BienPhapTranhThay ||
                "&nbsp;"
              }}</span>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12">
            <div>
              <span class="form-label">Kỳ có thai cuối cùng:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_KyThaiCuoiCung || "&nbsp;"
              }}</span>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="4">
            <div>
              <span class="form-label">Số lần có thai:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_SoLanCoThay || "&nbsp;"
              }}</span>
            </div>
          </b-col>
          <b-col md="4">
            <div>
              <span class="form-label">Số lần sảy thai:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_SoLanSayThay || "&nbsp;"
              }}</span>
            </div>
          </b-col>
          <b-col md="4">
            <div>
              <span class="form-label">Số lần phá thai:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_SoLanPhaThay || "&nbsp;"
              }}</span>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="3">
            <div>
              <span class="form-label">Số lần sinh đẻ:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_SoLanSinhDe || "&nbsp;"
              }}</span>
            </div>
          </b-col>
          <b-col md="3">
            <div>
              <span class="form-label">Đẻ thường:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_SoLanDeThuong || "&nbsp;"
              }}</span>
            </div>
          </b-col>
          <b-col md="3">
            <div>
              <span class="form-label">Đẻ mổ:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_SoLanDeMo || "&nbsp;"
              }}</span>
            </div>
          </b-col>
          <b-col md="3">
            <div>
              <span class="form-label">Đẻ khó:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_SoLanDeKho || "&nbsp;"
              }}</span>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="4">
            <div>
              <span class="form-label">Số lần đẻ đủ tháng:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_SoLanDeDuThang || "&nbsp;"
              }}</span>
            </div>
          </b-col>
          <b-col md="4">
            <div>
              <span class="form-label">Số lần đẻ non:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_SoLanDeNon || "&nbsp;"
              }}</span>
            </div>
          </b-col>
          <b-col md="4">
            <div>
              <span class="form-label">Số con sống hiện tại:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_SoConSongHienTai || "&nbsp;"
              }}</span>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12">
            <div>
              <span class="form-label">Bệnh phụ khoa:</span>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B7_BenhPhuKhoa || "&nbsp;"
              }}</span>
            </div>
          </b-col>
        </b-row>
      </div>
    </el-dialog>

    <!-- modal B8-->
    <el-dialog
      title="Lịch sử chỉnh sửa"
      :visible.sync="mData.dialog.dialogB8.visibleDialog"
      width="70%"
      top="51px"
      :close-on-click-modal="false"
    >
      <div class="card-body">
        <b-row class="mb-2">
          <b-col md="6" class="bold-500">Chỉnh sửa ngày: 05/02/2020</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="12">
            <div>
              <span class="form-value">{{
                mData.dataForm.ThongTinHanhChinh.B8_CacVanDeKhac || "&nbsp;"
              }}</span>
            </div>
          </b-col>
        </b-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import KhaoSatApi from "../../../moduleApi/KhaoSatApi";
import Hssk831Api from "../../../moduleApi/Hssk831Api";

import Hssk831Model from "./HsskBNModel";
import COSApi from "../../../moduleApi/COSApi";
import moment from "moment";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "HsskBN",
        currentUser: MethodService.getCurrentUser(),
        listData: [],
        dataForm: MethodService.copyObject(Hssk831Model.dataForm),
        validForm: Hssk831Model.validForm,
        dialog: {
          dialogB2: {
            visibleDialog: false,
            data: [],
          },
          dialogB3: {
            visibleDialog: false,
            data: [],
          },
          dialogB4: {
            visibleDialog: false,
            data: [],
          },
          dialogB5: {
            visibleDialog: false,
            data: [],
          },
          dialogB6: {
            visibleDialog: false,
            data: [],
          },
          dialogB7: {
            visibleDialog: false,
            data: [],
          },
          dialogB8: {
            visibleDialog: false,
            data: [],
          },
        },

        dataDefault: {
          HSSKCN_id: null,
          YeuToSucKhoe: [],
          KhuyetTat: [],
          BenhTat: [],
          DiUng: [],
          Vacxin: [],
        },
      },
      tabIndex: [0, 0],
    };
  },

  methods: {
    Test(value, operation) {
      let patt = new RegExp(operation);
      return patt.test(value);
    },

    async fn_getDataByCardCode() {
      try {
        if (this.$router.currentRoute.params.id) {
          let dataInfoBN = JSON.parse(
            sessionStorage.getItem(this.$router.currentRoute.params.id)
          );
          if (dataInfoBN) {
            this.mData.dataForm.ThongTinHanhChinh = Object.assign(dataInfoBN, {
              NGAY_SINH_new: `${dataInfoBN.NAM_SINH}-${dataInfoBN.THANG_SINH}-${dataInfoBN.NGAY_SINH}T00:00:00`,
              SOTHEBHYT: dataInfoBN.SoTheBHYT,
              MA_TINH_THANH: dataInfoBN.MA_TINH,
              NOI_O_MA_TINH_THANH: dataInfoBN.NOI_O_MA_TINH,
              MA_QUAN_HUYEN: dataInfoBN.MA_HUYEN,
              NOI_O_MA_QUAN_HUYEN: dataInfoBN.NOI_O_MA_HUYEN,
              MA_PHUONG_XA: dataInfoBN.MA_XA,
              NOI_O_MA_PHUONG_XA: dataInfoBN.NOI_O_MA_XA,
            });
            console.log(
              "this.mData.dataForm.ThongTinHanhChinh",
              this.mData.dataForm.ThongTinHanhChinh
            );
            this.mData.dataDefault.HSSKCN_id = null;
            this.reloadAdress();
          } else {
            if (!this.Test(this.$router.currentRoute.params.id, "-")) {
              let CardCode = this.$router.currentRoute.params.id;
              let res831 = await KhaoSatApi.getHSSK831(CardCode);
              if (
                res831 &&
                res831.data &&
                res831.data[0] &&
                res831.data[0].ThongTinHanhChinh
              ) {
                let dataInfoBNApi = res831.data[0].ThongTinHanhChinh;
                this.mData.dataForm.ThongTinHanhChinh = Object.assign(
                  dataInfoBNApi,
                  {
                    NGAY_SINH_new: `${dataInfoBNApi.NAM_SINH}-${dataInfoBNApi.THANG_SINH}-${dataInfoBNApi.NGAY_SINH}T00:00:00`,
                    SOTHEBHYT: dataInfoBNApi.SoTheBHYT,
                    MA_TINH_THANH: dataInfoBNApi.MA_TINH,
                    NOI_O_MA_TINH_THANH: dataInfoBNApi.NOI_O_MA_TINH,
                    MA_QUAN_HUYEN: dataInfoBNApi.MA_HUYEN,
                    NOI_O_MA_QUAN_HUYEN: dataInfoBNApi.NOI_O_MA_HUYEN,
                    MA_PHUONG_XA: dataInfoBNApi.MA_XA,
                    NOI_O_MA_PHUONG_XA: dataInfoBNApi.NOI_O_MA_XA,
                  }
                );
                console.log(
                  "this.mData.dataForm.ThongTinHanhChinh",
                  this.mData.dataForm.ThongTinHanhChinh
                );
                this.mData.dataDefault.HSSKCN_id = null;
                this.reloadAdress();
              } else {
                let res = await COSApi.GetInfoUser(CardCode);
                if (res && res.data && res.data.Data && res.data.Data[0]) {
                  let dataBhyt =
                    res.data.Data[0].Bhyts && res.data.Data[0].Bhyts[0]
                      ? res.data.Data[0].Bhyts[0]
                      : null;
                  let dataInforUser = res.data.Data[0];
                  let data = { ...this.mData.dataForm };
                  data.ThongTinHanhChinh.HO_TEN = dataInforUser.FullName;
                  data.ThongTinHanhChinh.DIEN_THOAI = dataInforUser.Phone;
                  data.ThongTinHanhChinh.NGAY_SINH_new = MethodService.NgaySinhSlice(
                    dataInforUser.Dob.toString()
                  );
                  data.ThongTinHanhChinh.DIA_CHI_DKTT = dataInforUser.Address;
                  data.ThongTinHanhChinh.CMND = dataInforUser.CmndNumber;
                  if (CardCode.length < 16) {
                    data.ThongTinHanhChinh.COS_MATHE_DANGKY = CardCode;
                  } else {
                    data.ThongTinHanhChinh.COS_MATHE = CardCode;
                  }
                  if (dataBhyt) {
                    data.ThongTinHanhChinh.SOTHEBHYT = dataBhyt.BhytNumber;
                  }
                }
              }
            } else {
              this.mData.dataDefault.HSSKCN_id = this.$router.currentRoute.params.id;
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async fn_initData() {
      if (this.mData.dataDefault.HSSKCN_id) {
        try {
          let res = await KhaoSatApi.GetHoSo831ByHSSKCN_ID(
            this.mData.dataDefault.HSSKCN_id
          );
          console.log("dataaaa", res);
          if (res) {
            this.mData.dataForm.ThongTinHanhChinh = Object.assign(
              res.data[0].ThongTinHanhChinh,
              {
                NGAY_SINH_new: `${res.data[0].ThongTinHanhChinh.namSinh}-${res.data[0].ThongTinHanhChinh.thangSinh}-${res.data[0].ThongTinHanhChinh.ngaySinh}T00:00:00`,
              }
            );
            this.mData.dataForm.ThongTinDieuTri = res.data[0].ThongTinDieuTri;
            this.mData.dataForm.KetQuaCanLamSang = res.data[0].KetQuaCanLamSang;
            // this.reloadAdress();

            // else if(MA_TINH_THANH&&NOI_O_MA_TINH_THANH){
            //     let res_MA_TINH_THANH = await KhaoSatApi.LoadDMQuanHuyen(MA_TINH_THANH);
            //     let res_NOI_O_MA_TINH_THANH = await KhaoSatApi.LoadDMQuanHuyen(NOI_O_MA_TINH_THANH);
            //     this.mData.dataDefault.dmQuanHuyen_thuongtru =  res_MA_TINH_THANH.data;
            //     this.mData.dataDefault.dmQuanHuyen_hientai =  res_NOI_O_MA_TINH_THANH.data;
            //     if(MA_QUAN_HUYEN && !NOI_O_MA_QUAN_HUYEN){
            //     this.fn_changeQuanHuyen_thuongtru(MA_QUAN_HUYEN)
            //   }else if(NOI_O_MA_QUAN_HUYEN && !MA_QUAN_HUYEN){
            //     this.fn_changeQuanHuyen_hientai(NOI_O_MA_QUAN_HUYEN)
            //   }else{
            //     let res_MA_QUAN_HUYEN = await KhaoSatApi.LoadDMPhuongXa(MA_TINH_THANH, MA_QUAN_HUYEN);
            //      let res_NOI_O_MA_QUAN_HUYEN = await KhaoSatApi.LoadDMPhuongXa(NOI_O_MA_TINH_THANH, NOI_O_MA_QUAN_HUYEN);
            //        this.mData.dataDefault.dmPhuongXa_thuongtru = res_MA_QUAN_HUYEN.data;
            //        this.mData.dataDefault.dmPhuongXa_hientai = res_NOI_O_MA_QUAN_HUYEN.data;
            //   }
            // }
          }
        } catch (error) {
          window.Swal.fire({
            icon: "error",
            text: "lỗi tải dư liệu!",
          });
        }
      }
    },
    async fn_initDataDefault() {
      let req_getYeuToSucKhoe = Hssk831Api.getYeuToSucKhoe();
      let req_getKhuyetTat = Hssk831Api.getKhuyetTat();
      let req_getBenhTat = Hssk831Api.getBenhTat();
      let req_getDiUng = Hssk831Api.getDiUng();
      let req_getVacxin = Hssk831Api.getVacxin();

      let res_getYeuToSucKhoe = await req_getYeuToSucKhoe;
      let res_getKhuyetTat = await req_getKhuyetTat;
      let res_getBenhTat = await req_getBenhTat;
      let res_getDiUng = await req_getDiUng;
      let res_getVacxin = await req_getVacxin;

      await this.fn_getDataByCardCode();

      if (this.mData.dataDefault.HSSKCN_id) {
        this.mData.hasHssk_id = true;
        this.fn_initData();
      } else {
        this.mData.dataDefault.HSSKCN_id = MethodService.createGuid();
      }

      this.mData.dataDefault.YeuToSucKhoe =
        res_getYeuToSucKhoe && res_getYeuToSucKhoe.result
          ? res_getYeuToSucKhoe.result
          : [];

      this.mData.dataDefault.KhuyetTat =
        res_getKhuyetTat && res_getKhuyetTat.result
          ? res_getKhuyetTat.result
          : [];

      this.mData.dataDefault.BenhTat =
        res_getBenhTat && res_getBenhTat.result ? res_getBenhTat.result : [];

      this.mData.dataDefault.DiUng =
        res_getDiUng && res_getDiUng.result ? res_getDiUng.result : [];

      this.mData.dataDefault.Vacxin =
        res_getVacxin && res_getVacxin.result ? res_getVacxin.result : [];
    },
    fn_formatDate(date) {
      return MethodService.formatDate(date, "date");
    },

    async fn_updateB1() {
      let arrObject = {
        HSSK_Id: this.mData.dataDefault.HSSKCN_id,
        TT_LUC_DE_ID: this.mData.dataDefault.HSSKCN_id,
        DE_THUONG:
          this.mData.dataForm.ThongTinHanhChinh.B1_TinhTrangLucSinh == "1"
            ? true
            : false,
        DE_MO:
          this.mData.dataForm.ThongTinHanhChinh.B1_TinhTrangLucSinh == "2"
            ? true
            : false,
        DE_THIEU_THANG: this.mData.dataForm.ThongTinHanhChinh.B1_DeThieuThang,
        BI_NGAT_LUC_DE: this.mData.dataForm.ThongTinHanhChinh.B1_BiNgatLucDe,
        CN_LUC_DE: this.mData.dataForm.ThongTinHanhChinh.B1_CanNang,
        CD_LUC_DE: this.mData.dataForm.ThongTinHanhChinh.B1_ChieuDaiLucDe,
        DI_TAT_BAM_SINH: this.mData.dataForm.ThongTinHanhChinh.B1_DiTatBamSinh,
        VAN_DE_KHAC: this.mData.dataForm.ThongTinHanhChinh.B1_Khac,
      };
      let res = await KhaoSatApi.SaveHSSK_TT_LUC_SINH(arrObject);
      if (res.data) {
        window.toastr.success("Cập nhật thành công");
      } else {
        window.toastr.error("Cập nhật không thành công");
      }
    },

    async fn_updateB2() {
      let arrObject = [];
      this.mData.dataDefault.YeuToSucKhoe.forEach((item) => {
        if ("HutThuoc" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            YTSK_Id: item.id,
            MO_TA: this.mData.dataForm.ThongTinHanhChinh.B2_HutThuoc,
            TAN_SUAT: this.mData.dataForm.ThongTinHanhChinh
              .B2_HutThuoc_ThuongXuyen,
            DA_BO: this.mData.dataForm.ThongTinHanhChinh.B2_HutThuoc_DaBo,
          });
        } else if ("RuouBia" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            YTSK_Id: item.id,
            MO_TA: this.mData.dataForm.ThongTinHanhChinh.B2_UongRuouBia,
            TAN_SUAT: this.mData.dataForm.ThongTinHanhChinh
              .B2_UongRuouBia_SoCoc,
            DA_BO: this.mData.dataForm.ThongTinHanhChinh.B2_UongRuouBia_DaBo,
          });
        } else if ("MaTuy" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            YTSK_Id: item.id,
            MO_TA: this.mData.dataForm.ThongTinHanhChinh.B2_MaTuy,
            TAN_SUAT: this.mData.dataForm.ThongTinHanhChinh
              .B2_MaTuy_ThuongXuyen,
            DA_BO: this.mData.dataForm.ThongTinHanhChinh.B2_MaTuy_DaBo,
          });
        } else if ("HoatDongTheLuc" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            YTSK_Id: item.id,
            MO_TA: this.mData.dataForm.ThongTinHanhChinh.B2_HoatDongTheLuc,
            TAN_SUAT: this.mData.dataForm.ThongTinHanhChinh
              .B2_HoatDongTheLuc_ThuongXuyen,
            DA_BO: false,
          });
        } else if ("YeuToTiepXuc" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            YTSK_Id: item.id,
            MO_TA: this.mData.dataForm.ThongTinHanhChinh.B2_YeuToTiepXuc,
            TAN_SUAT: this.mData.dataForm.ThongTinHanhChinh.B2_ThoiGianTiepXuc,
            DA_BO: false,
          });
        } else if ("LoaiHoXi" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            YTSK_Id: item.id,
            MO_TA: this.mData.dataForm.ThongTinHanhChinh.B2_LoaiHoXi,
            TAN_SUAT: "",
            DA_BO: false,
          });
        } else if ("NguyCoKhac" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            YTSK_Id: item.id,
            MO_TA: this.mData.dataForm.ThongTinHanhChinh.B2_NguyCoKhac,
            TAN_SUAT: "",
            DA_BO: false,
          });
        }
      });
      let res = await KhaoSatApi.SaveHSSK_YTSK(arrObject);
      if (res.data) {
        window.toastr.success("Cập nhật thành công");
      } else {
        window.toastr.error("Cập nhật không thành công");
      }
    },

    async fn_updateB3() {
      let arrObject = [];
      this.mData.dataDefault.BenhTat.forEach((item) => {
        if ("TimMach" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B3_BenhTimMach,
          });
        } else if ("TangHuyetAp" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B3_BenhTangHuyetAp,
          });
        } else if ("DaiDuong" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B3_BenhDaiDuong,
          });
        } else if ("DaDay" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B3_BenhDaDay,
          });
        } else if ("Phoi" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B3_BenhPhoiManTinh,
          });
        } else if ("HenSuyen" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B3_BenhHenSuyen,
          });
        } else if ("BuouCo" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B3_BenhBuouCo,
          });
        } else if ("Gan" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B3_BenhViemGan,
          });
        } else if ("TimBamSinh" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B3_BenhTimBamSinh,
          });
        } else if ("TamThan" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B3_BenhTamThan,
          });
        } else if ("TuKy" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B3_BenhTuKy,
          });
        } else if ("DongKinh" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B3_BenhDongKinh,
          });
        } else if ("UngThu" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B3_BenhUngThu,
            MAC_BENH: false,
          });
        } else if ("Lao" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B3_BenhLao,
            MAC_BENH: false,
          });
        } else if ("NguyCoKhac" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B3_BenhKhac,
            MAC_BENH: false,
          });
        }
      });

      let arrObjectDiUng = [];
      this.mData.dataDefault.DiUng.forEach((item) => {
        if ("ThuocLa" == item.code.trim()) {
          arrObjectDiUng.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            DIUNG_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B3_DiUngThuoc,
          });
        } else if ("HoaChatMyPham" == item.code.trim()) {
          arrObjectDiUng.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            DIUNG_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B3_DiUngHoaChatMyPham,
          });
        } else if ("ThucPham" == item.code.trim()) {
          arrObjectDiUng.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            DIUNG_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B3_DiUngThucPham,
          });
        } else if ("Khac" == item.code.trim()) {
          arrObjectDiUng.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            DIUNG_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B3_DiUngKhac,
          });
        }
      });

      let res = await KhaoSatApi.SaveHSSK_DIUNG(arrObjectDiUng);
      if (res.data) {
        window.toastr.success("Cập nhật dị ứng thành công");
      } else {
        window.toastr.error("Cập nhật dị ứng không thành công");
      }

      let res2 = await KhaoSatApi.SaveHSSK_BENHTAT(arrObject);
      if (res2.data) {
        window.toastr.success("Cập nhật bệnh tật thành công");
      } else {
        window.toastr.error("Cập nhật bệnh tật không thành công");
      }
    },

    async fn_updateB4() {
      let arrObject = [];
      this.mData.dataDefault.KhuyetTat.forEach((item) => {
        if ("ThinhGiac" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            KTAT_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B4_ThinhLuc,
          });
        } else if ("ThiLuc" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            KTAT_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B4_ThiLuc,
          });
        } else if ("Tay" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            KTAT_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B4_Tay,
          });
        } else if ("Chan" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            KTAT_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B4_Chan,
          });
        } else if ("CotSong" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            KTAT_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B4_CongVeoCotSong,
          });
        } else if ("MoiVomMien" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            KTAT_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B4_HoMoi,
          });
        } else if ("Khac" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            KTAT_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B4_Khac,
          });
        }
      });

      let res = await KhaoSatApi.SaveHSSK_KTAT(arrObject);
      if (res.data) {
        window.toastr.success("Cập nhật thành công");
      } else {
        window.toastr.error("Cập nhật không thành công");
      }
    },

    async fn_updateB5() {
      if (!this.mData.hasHssk_id) {
        window.toastr.warning(
          "Bạn cần cập nhật lại thông tin hành chính trước!"
        );
        return;
      }

      let arrObject = [];
      arrObject.push({
        HSSK_Id: this.mData.dataDefault.HSSKCN_id,
        PTHUAT_Id: this.mData.dataDefault.HSSKCN_id,
        MOTA: this.mData.dataForm.ThongTinHanhChinh.B5_TienSuPhauThuat,
      });
      let res = await KhaoSatApi.SaveHSSK_PTHUAT(arrObject);
      if (res.data) {
        window.toastr.success("Cập nhật thành công");
      } else {
        window.toastr.error("Cập nhật không thành công");
      }
    },

    async fn_updateB6() {
      let arrObject = [];
      this.mData.dataDefault.BenhTat.forEach((item) => {
        if ("TimMach" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            NGUOI_MAC: this.mData.dataForm.ThongTinHanhChinh
              .B6_GDBenhTim_NguoiMac,
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B6_GDBenhTim,
          });
        } else if ("HenSuyen" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            NGUOI_MAC: this.mData.dataForm.ThongTinHanhChinh
              .B6_GDHenSuyen_NguoiMac,
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B6_GDHenSuyen,
          });
        } else if ("TangHuyetAp" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            NGUOI_MAC: this.mData.dataForm.ThongTinHanhChinh
              .B6_GDTangHuyetAp_NguoiMac,
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B6_GDTangHuyetAp,
          });
        } else if ("DaiDuong" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            NGUOI_MAC: this.mData.dataForm.ThongTinHanhChinh
              .B6_GDDaiDuong_NguoiMac,
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B6_GDDaiDuong,
          });
        } else if ("TamThan" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            NGUOI_MAC: this.mData.dataForm.ThongTinHanhChinh
              .B6_GDTamThan_NguoiMac,
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B6_GDTamThan,
          });
        } else if ("DongKinh" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: "",
            NGUOI_MAC: this.mData.dataForm.ThongTinHanhChinh
              .B6_GDDongKinh_NguoiMac,
            MAC_BENH: this.mData.dataForm.ThongTinHanhChinh.B6_GDDongKinh,
          });
        } else if ("UngThu" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B6_GDUngThu,
            NGUOI_MAC: "",
            MAC_BENH: false,
          });
        } else if ("Lao" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B6_GDLao,
            NGUOI_MAC: "",
            MAC_BENH: false,
          });
        } else if ("NguyCoKhac" == item.code.trim()) {
          arrObject.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            LBENH_CN_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B6_GDKhac,
            NGUOI_MAC: "",
            MAC_BENH: false,
          });
        }
      });

      let arrObjectDiUng = [];
      this.mData.dataDefault.DiUng.forEach((item) => {
        if ("ThuocLa" == item.code.trim()) {
          arrObjectDiUng.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            DIUNG_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B6_GDDiUngThuoc,
            NGUOI_MAC: this.mData.dataForm.ThongTinHanhChinh
              .B6_GDDiUngThuoc_NguoiMac,
          });
        } else if ("HoaChatMyPham" == item.code.trim()) {
          arrObjectDiUng.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            DIUNG_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B6_GDDiUngHoaChatMyPham,
            NGUOI_MAC: this.mData.dataForm.ThongTinHanhChinh
              .B6_GDDiUngHoaChatMyPham_NguoiMac,
          });
        } else if ("ThucPham" == item.code.trim()) {
          arrObjectDiUng.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            DIUNG_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B6_GDDiUngThucPham,
            NGUOI_MAC: this.mData.dataForm.ThongTinHanhChinh
              .B6_GDDiUngThucPham_NguoiMac,
          });
        } else if ("Khac" == item.code.trim()) {
          arrObjectDiUng.push({
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            DIUNG_Id: item.id,
            MOTA: this.mData.dataForm.ThongTinHanhChinh.B6_GDDiUngKhac,
            NGUOI_MAC: this.mData.dataForm.ThongTinHanhChinh
              .B6_GDDiUngKhac_NguoiMac,
          });
        }
      });

      let res = await KhaoSatApi.SaveHSSK_DIUNG_GD(arrObjectDiUng);
      if (res.data) {
        window.toastr.success("Cập nhật dị ứng thành công");
      } else {
        window.toastr.error("Cập nhật dị ứng không thành công");
      }

      let res2 = await KhaoSatApi.SaveHSSK_BENHTATGD(arrObject);

      if (res2.data) {
        window.toastr.success("Cập nhật bệnh tật thành công");
      } else {
        window.toastr.error("Cập nhật bệnh tật không thành công");
      }
    },

    async fn_updateB7() {
      let arrObject = {
        HSSK_Id: this.mData.dataDefault.HSSKCN_id,
        BP_TRANH_THAI: this.mData.dataForm.ThongTinHanhChinh
          .B7_BienPhapTranhThay,
        KY_THAI_CUOI: this.mData.dataForm.ThongTinHanhChinh.B7_KyThaiCuoiCung,
        SL_CO_THAI: this.mData.dataForm.ThongTinHanhChinh.B7_SoLanCoThay,
        SL_SAY_THAI: this.mData.dataForm.ThongTinHanhChinh.B7_SoLanSayThay,
        SL_PHA_THAI: this.mData.dataForm.ThongTinHanhChinh.B7_SoLanPhaThay,
        SL_DE: this.mData.dataForm.ThongTinHanhChinh.B7_SoLanSinhDe,
        SL_DE_THUONG: this.mData.dataForm.ThongTinHanhChinh.B7_SoLanDeThuong,
        SL_DE_KHO: this.mData.dataForm.ThongTinHanhChinh.B7_SoLanDeKho,
        SL_DE_MO: this.mData.dataForm.ThongTinHanhChinh.B7_SoLanDeMo,
        SL_DE_DTHANG: this.mData.dataForm.ThongTinHanhChinh.B7_SoLanDeDuThang,
        SL_DE_NON: this.mData.dataForm.ThongTinHanhChinh.B7_SoLanDeNon,
        SO_CON: this.mData.dataForm.ThongTinHanhChinh.B7_SoConSongHienTai,
        BENH_PSAN: this.mData.dataForm.ThongTinHanhChinh.B7_BenhPhuKhoa,
      };

      let res = await KhaoSatApi.SaveHSSK_SKSS(arrObject);
      if (res.data) {
        window.toastr.success("Cập nhật thành công");
      } else {
        window.toastr.error("Cập nhật không thành công");
      }
    },

    async fn_updateB8() {
      let arrObject = [];
      arrObject.push({
        HSSK_Id: this.mData.dataDefault.HSSKCN_id,
        HSSK_VANDE_KHAC_Id: this.mData.dataDefault.HSSKCN_id,
        VAN_DE: this.mData.dataForm.ThongTinHanhChinh.B8_CacVanDeKhac,
      });
      let res = await KhaoSatApi.SaveHSSK_VANDE_KHAC(arrObject);
      if (res.data) {
        window.toastr.success("Cập nhật thành công");
      } else {
        window.toastr.error("Cập nhật không thành công");
      }
    },

    fn_gotoDetail() {
      this.$router.push({ name: "Admin-HsskBN-list" });
    },
  },

  created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update-sk"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
  },
  async mounted() {
    await this.fn_initDataDefault();
    // this.fn_initData();
  },
};
</script>
<style scoped>
</style>